import Cookie from '@modules/cookie';

const watchers: Array<(isDarkMode: boolean) => void> = [];

export default class DarkMode {
    public static readonly CSS_CLASS: string = 'xer-dark';

    public isDarkMode = (): boolean => Cookie.get(Cookie.keys.IS_DARK_MODE) === 'true';

    public enable = (): void => {
        window.document.documentElement.classList.add(DarkMode.CSS_CLASS);
        this.setCookie(true);
        watchers.forEach((func) => func(true));
    };

    public disable = (): void => {
        window.document.documentElement.classList.remove(DarkMode.CSS_CLASS);
        this.setCookie(false);
        watchers.forEach((func) => func(false));
    };

    public watch = (func: (isDarkMode: boolean) => void): void => {
        watchers.push(func);
    };

    private setCookie = (value: boolean): void => {
        Cookie.set(Cookie.keys.IS_DARK_MODE, JSON.stringify(value));
    };
}
